/*
 * vrtPSTrainer.ts
 */
import type { RouteRecordRaw } from 'vue-router';
//
const vrtPSTrainer: RouteRecordRaw = {
  path: '/powersteer/trainer',
  name: 'vrtPSTrainer',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    // TRAINEE OPERATION
    {
      path: 'trainee/operation/paradestate/list',
      name: 'vrtPSTrainerFrameTraineeParadeStateList',
      component: () => import('./vpgPSTrainerFrameTraineeParadeStateList.vue'),
    },
    {
      path: 'trainee/operation/daily-training-scheduler',
      name: 'vrtPSTrainerDailyTrainingScheduler',
      component: () => import('./vpgPSTrainerDailyTrainingScheduler.vue'),
    },
    {
      path: 'trainee/operation/paradestate/operate',
      name: 'vrtPSTrainerFrameTraineeParadeStateOperate',
      component: () => import('./vpgPSTrainerFrameTraineeParadeStateOperate.vue'),
    },
    {
      path: 'trainee/operation/paradestate/history/list',
      name: 'vrtPSTrainerFrameTraineeParadeStateHistoryList',
      component: () => import('./vpgPSTrainerFrameTraineeParadeStateHistoryList.vue'),
    },
    {
      path: 'trainee/operation/paradestate/history/operate',
      name: 'vrtPSTrainerFrameTraineeParadeStateHistoryOperate',
      component: () => import('./vpgPSTrainerFrameTraineeParadeStateHistoryOperate.vue'),
    },
    {
      path: 'trainee/operation/lesson/conducted/list',
      name: 'vrtPSTrainerFrameLessonConductedList',
      component: () => import('./vpgPSTrainerFrameLessonConductedList.vue'),
    },
    {
      path: 'trainee/operation/lesson/conducted/operate/add',
      name: 'vrtPSTrainerFLCOperateAdd0Control',
      component: () => import('./vpgPSTrainerFLCOperateAdd0Control.vue'),
      children: [
        {
          path: '1/frame',
          name: 'vrtPSTrainerFLCOperateAdd1Frame',
          component: () => import('./vpgPSTrainerFLCOperateAdd1Frame.vue'),
        },
        {
          path: '2/trainer/:vpsIDPSFrame',
          name: 'vrtPSTrainerFLCOperateAdd2Trainer',
          component: () => import('./vpgPSTrainerFLCOperateAdd2Trainer.vue'),
          props: true,
        },
        {
          path: '3/lesson/:vpsIDPSCourseType',
          name: 'vrtPSTrainerFLCOperateAdd3Lesson',
          component: () => import('./vpgPSTrainerFLCOperateAdd3Lesson.vue'),
          props: true,
        },
        {
          path: '4/vehicle/:vpsIDPSCourseType',
          name: 'vrtPSTrainerFLCOperateAdd4Vehicle',
          component: () => import('./vpgPSTrainerFLCOperateAdd4Vehicle.vue'),
          props: true,
        },
        {
          path: '5/lesson/datetime/start/:vpsPSLessonDateTimeIMS',
          name: 'vrtPSTrainerFLCOperateAdd5LessonDTStart',
          component: () => import('./vpgPSTrainerFLCOperateAdd5LessonDTStart.vue'),
          props: true,
        },
        {
          path: '6/lesson/datetime/end/:vpsPSLessonDateTimeIMS',
          name: 'vrtPSTrainerFLCOperateAdd6LessonDTEnd',
          component: () => import('./vpgPSTrainerFLCOperateAdd6LessonDTEnd.vue'),
          props: true,
        },
        {
          path: '7/trainee/:vpsIDPSFrame',
          name: 'vrtPSTrainerFLCOperateAdd7Trainee',
          component: () => import('./vpgPSTrainerFLCOperateAdd7Trainee.vue'),
          props: true,
        },
        {
          path: '8/signature',
          name: 'vrtPSTrainerFLCOperateAdd8Signature',
          component: () => import('./vpgPSTrainerFLCOperateAdd8Signature.vue'),
        },
      ],
    },
    {
      path: 'trainee/operation/lesson/conducted/operate/view',
      name: 'vrtPSTrainerFLCOperateView',
      component: () => import('./vpgPSTrainerFLCOperateView.vue'),
    },
    // TRAINEE ASSESSMENT
    // {}
    // TTS - CL3 v4
    {
      path: 'tts/cl3/v4/list',
      name: 'vrtPSTrainerTTSCL3v4List',
      component: () => import('./vpgPSTrainerTTSCL3v4List.vue'),
    },
    {
      path: 'tts/cl3/v4/operate',
      name: 'vrtPSTrainerTTSCL3v4Operate',
      component: () => import('./vpgPSTrainerTTSCL3v4Operate.vue'),
    },
    {
      path: 'tts/cl3/v4/operate/2/summary',
      name: 'vrtPSTrainerTTSCL3v4Operate2Summary',
      component: () => import('./vpgPSTrainerTTSCL3v4Operate2Summary.vue'),
    },
    {
      path: 'tts/cl3/v4/operate/1/tts',
      name: 'vrtPSTrainerTTSCL3v4Operate1TTS',
      component: () => import('./vpgPSTrainerTTSCL3v4Operate1TTS.vue'),
    },
    // TTS - CL3 v5
    {
      path: 'tts/cl3/v5/list',
      name: 'vrtPSTrainerTTSCL3v5List',
      component: () => import('./vpgPSTrainerTTSCL3v5List.vue'),
    },
    {
      path: 'tts/cl3/v5/operate',
      name: 'vrtPSTrainerTTSCL3v5Operate',
      component: () => import('./vpgPSTrainerTTSCL3v5Operate.vue'),
    },
    {
      path: 'tts/cl3/v5/operate/1/tts',
      name: 'vrtPSTrainerTTSCL3v5Operate1TTS',
      component: () => import('./vpgPSTrainerTTSCL3v5Operate1TTS.vue'),
    },
    {
      path: 'tts/cl3/v5/operate/2/iwcd',
      name: 'vrtPSTrainerTTSCL3v5Operate2IWCD',
      component: () => import('./vpgPSTrainerTTSCL3v5Operate2IWCD.vue'),
    },
    {
      path: 'tts/cl3/v5/operate/3/rp',
      name: 'vrtPSTrainerTTSCL3v5Operate3RP',
      component: () => import('./vpgPSTrainerTTSCL3v5Operate3RP.vue'),
    },
    {
      path: 'tts/cl3/v5/operate/4/view/all',
      name: 'vrtPSTrainerTTSCL3v5Operate4ViewAll',
      component: () => import('./vpgPSTrainerTTSCL3v5Operate4ViewAll.vue'),
    },
    // TTS - CL3M
    {
      path: 'tts/cl3/m/list',
      name: 'vrtPSTrainerTTSCL3MList',
      component: () => import('./vpgPSTrainerTTSCL3MList.vue'),
    },
    {
      path: 'tts/cl3/m/operate',
      name: 'vrtPSTrainerTTSCL3MOperate',
      component: () => import('./vpgPSTrainerTTSCL3MOperate.vue'),
    },
    {
      path: 'tts/cl3/m/operate/1/tts',
      name: 'vrtPSTrainerTTSCL3MOperate1TTS',
      component: () => import('./vpgPSTrainerTTSCL3MOperate1TTS.vue'),
    },
    {
      path: 'tts/cl3/m/operate/2/iwcd',
      name: 'vrtPSTrainerTTSCL3MOperate2IWCD',
      component: () => import('./vpgPSTrainerTTSCL3MOperate2IWCD.vue'),
    },
    {
      path: 'tts/cl3/m/operate/3/rp',
      name: 'vrtPSTrainerTTSCL3MOperate3RP',
      component: () => import('./vpgPSTrainerTTSCL3MOperate3RP.vue'),
    },
    {
      path: 'tts/cl3/m/operate/summary/7s00',
      name: 'vrtPSTrainerTTSCL3MOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - CL4D41
    {
      path: 'tts/cl4/d41/list',
      name: 'vrtPSTrainerTTSCL4D41List',
      component: () => import('./vpgPSTrainerTTSCL4D41List.vue'),
    },
    // TTS - CL4D41 - Basic
    {
      path: 'tts/cl4/d41/operate/basic',
      name: 'vrtPSTrainerTTSCL4D41Operate1B00',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B00.vue'),
    },
    // TTS - CL4D41 - Basic - B01 ... B10
    {
      path: 'tts/cl4/d41/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL4D41Operate1B01',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B01.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b02',
      name: 'vrtPSTrainerTTSCL4D41Operate1B02',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B02.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b03',
      name: 'vrtPSTrainerTTSCL4D41Operate1B03',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B03.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b04',
      name: 'vrtPSTrainerTTSCL4D41Operate1B04',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B04.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b05',
      name: 'vrtPSTrainerTTSCL4D41Operate1B05',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B05.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b06',
      name: 'vrtPSTrainerTTSCL4D41Operate1B06',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B06.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b07',
      name: 'vrtPSTrainerTTSCL4D41Operate1B07',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B07.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b08',
      name: 'vrtPSTrainerTTSCL4D41Operate1B08',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B08.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b09',
      name: 'vrtPSTrainerTTSCL4D41Operate1B09',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B09.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/basic/b99',
      name: 'vrtPSTrainerTTSCL4D41Operate1B99',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate1B99.vue'),
    },
    // TTS - CL4D41 - AO
    {
      path: 'tts/cl4/d41/operate/ao',
      name: 'vrtPSTrainerTTSCL4D41Operate2A00',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate2A00.vue'),
    },
    // TTS - CL4D41 - AO - A01 ... A04
    {
      path: 'tts/cl4/d41/operate/ao/a01',
      name: 'vrtPSTrainerTTSCL4D41Operate2A01',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate2A01.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/ao/a02',
      name: 'vrtPSTrainerTTSCL4D41Operate2A02',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate2A02.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/ao/a03',
      name: 'vrtPSTrainerTTSCL4D41Operate2A03',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate2A03.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/ao/a04',
      name: 'vrtPSTrainerTTSCL4D41Operate2A04',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate2A04.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/ao/a99',
      name: 'vrtPSTrainerTTSCL4D41Operate2A99',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate2A99.vue'),
    },
    // TTS - CL4D41 - SUMMARY - LUV Phase
    {
      path: 'tts/cl4/d41/operate/summary/3s00',
      name: 'vrtPSTrainerTTSCL4D41Operate3S00',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate3S00.vue'),
    },
    // TTS - CL4D41 - SUMMARY - IVECO CD Phase
    {
      path: 'tts/cl4/d41/operate/summary/4s00',
      name: 'vrtPSTrainerTTSCL4D41Operate4S00',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate4S00.vue'),
    },
    // TTS - CL4D41 - SUMMARY - IVECO PD Phase
    {
      path: 'tts/cl4/d41/operate/summary/5s00',
      name: 'vrtPSTrainerTTSCL4D41Operate5S00',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate5S00.vue'),
    },
    // TTS - CL4D41 - SUMMARY - Advance
    {
      path: 'tts/cl4/d41/operate/summary/6s00',
      name: 'vrtPSTrainerTTSCL4D41Operate6S00',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate6S00.vue'),
    },
    // TTS - CL4D41 - SUMMARY - Advance totals
    {
      path: 'tts/cl4/d41/operate/summary/6s01',
      name: 'vrtPSTrainerTTSCL4D41Operate6S01',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate6S01.vue'),
    },
    // TTS - CL4D41 - SUMMARY - EOC (TMO)
    {
      path: 'tts/cl4/d41/operate/summary/7s00',
      name: 'vrtPSTrainerTTSCL4D41Operate7S00',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate7S00.vue'),
    },
    // TTS - CL4D41 - SUMMARY - Individual Trainee TTS Test Prep & Endorsement
    {
      path: 'tts/cl4/d41/operate/summary/8s00',
      name: 'vrtPSTrainerTTSCL4D41Operate8S00',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate8S00.vue'),
    },
    {
      path: 'tts/cl4/d41/operate/summary/8s01',
      name: 'vrtPSTrainerTTSCL4D41Operate8S01',
      component: () => import('./vpgPSTrainerTTSCL4D41Operate8S01.vue'),
    },
    // TTS - CL4D67
    {
      path: 'tts/cl4/d67/list',
      name: 'vrtPSTrainerTTSCL4D67List',
      component: () => import('./vpgPSTrainerTTSCL4D67List.vue'),
    },
    // TTS - CL4D67 - Basic
    {
      path: 'tts/cl4/d67/operate/basic',
      name: 'vrtPSTrainerTTSCL4D67Operate1B00',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B00.vue'),
    },
    // TTS - CL4D67 - Basic - B01 ... B10
    {
      path: 'tts/cl4/d67/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL4D67Operate1B01',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B01.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b02',
      name: 'vrtPSTrainerTTSCL4D67Operate1B02',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B02.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b03',
      name: 'vrtPSTrainerTTSCL4D67Operate1B03',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B03.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b04',
      name: 'vrtPSTrainerTTSCL4D67Operate1B04',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B04.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b05',
      name: 'vrtPSTrainerTTSCL4D67Operate1B05',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B05.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b06',
      name: 'vrtPSTrainerTTSCL4D67Operate1B06',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B06.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b07',
      name: 'vrtPSTrainerTTSCL4D67Operate1B07',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B07.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b08',
      name: 'vrtPSTrainerTTSCL4D67Operate1B08',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B08.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b09',
      name: 'vrtPSTrainerTTSCL4D67Operate1B09',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B09.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/basic/b99',
      name: 'vrtPSTrainerTTSCL4D67Operate1B99',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate1B99.vue'),
    },
    // TTS - CL4D67 - AO
    {
      path: 'tts/cl4/d67/operate/ao',
      name: 'vrtPSTrainerTTSCL4D67Operate2A00',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate2A00.vue'),
    },
    // TTS - CL4D67 - AO - A01 ... A04
    {
      path: 'tts/cl4/d67/operate/ao/a01',
      name: 'vrtPSTrainerTTSCL4D67Operate2A01',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate2A01.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/ao/a02',
      name: 'vrtPSTrainerTTSCL4D67Operate2A02',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate2A02.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/ao/a03',
      name: 'vrtPSTrainerTTSCL4D67Operate2A03',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate2A03.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/ao/a04',
      name: 'vrtPSTrainerTTSCL4D67Operate2A04',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate2A04.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/ao/a99',
      name: 'vrtPSTrainerTTSCL4D67Operate2A99',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate2A99.vue'),
    },
    // TTS - CL4D67 - SUMMARY - LUV Phase
    {
      path: 'tts/cl4/d67/operate/summary/3s00',
      name: 'vrtPSTrainerTTSCL4D67Operate3S00',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate3S00.vue'),
    },
    // TTS - CL4D67 - SUMMARY - IVECO CD Phase
    {
      path: 'tts/cl4/d67/operate/summary/4s00',
      name: 'vrtPSTrainerTTSCL4D67Operate4S00',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate4S00.vue'),
    },
    // TTS - CL4D67 - SUMMARY - IVECO PD Phase
    {
      path: 'tts/cl4/d67/operate/summary/5s00',
      name: 'vrtPSTrainerTTSCL4D67Operate5S00',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate5S00.vue'),
    },
    // TTS - CL4D67 - SUMMARY - Advance
    {
      path: 'tts/cl4/d67/operate/summary/6s00',
      name: 'vrtPSTrainerTTSCL4D67Operate6S00',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate6S00.vue'),
    },
    // TTS - CL4D67 - SUMMARY - EOC (TMO)
    {
      path: 'tts/cl4/d67/operate/summary/7s00',
      name: 'vrtPSTrainerTTSCL4D67Operate7S00',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate7S00.vue'),
    },
    // TTS - CL4D67 - SUMMARY - Individual Trainee TTS Test Prep & Endorsement
    {
      path: 'tts/cl4/d67/operate/summary/8s00',
      name: 'vrtPSTrainerTTSCL4D67Operate8S00',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate8S00.vue'),
    },
    {
      path: 'tts/cl4/d67/operate/summary/8s01',
      name: 'vrtPSTrainerTTSCL4D67Operate8S01',
      component: () => import('./vpgPSTrainerTTSCL4D67Operate8S01.vue'),
    },
    // TTS - CL4M
    {
      path: 'tts/cl4/m/list',
      name: 'vrtPSTrainerTTSCL4MList',
      component: () => import('./vpgPSTrainerTTSCL4MList.vue'),
    },
    {
      path: 'tts/cl4/m/operate',
      name: 'vrtPSTrainerTTSCL4MOperate',
      component: () => import('./vpgPSTrainerTTSCL4MOperate.vue'),
    },
    {
      path: 'tts/cl4/m/operate/1/tts',
      name: 'vrtPSTrainerTTSCL4MOperate1TTS',
      component: () => import('./vpgPSTrainerTTSCL4MOperate1TTS.vue'),
    },
    {
      path: 'tts/cl4/m/operate/2/iwcd',
      name: 'vrtPSTrainerTTSCL4MOperate2IWCD',
      component: () => import('./vpgPSTrainerTTSCL4MOperate2IWCD.vue'),
    },
    {
      path: 'tts/cl4/m/operate/4/rp',
      name: 'vrtPSTrainerTTSCL4MOperate3RP',
      component: () => import('./vpgPSTrainerTTSCL4MOperate3RP.vue'),
    },
    // TTS - XCTRY
    {
      path: 'tts/xctry/list',
      name: 'vrtPSTrainerTTSXCTRYList',
      component: () => import('./vpgPSTrainerTTSXCTRYList.vue'),
    },
    {
      path: 'tts/xctry/operate',
      name: 'vrtPSTrainerTTSXCTRYOperate',
      component: () => import('./vpgPSTrainerTTSXCTRYOperate.vue'),
    },
    {
      path: 'tts/xctry/operate/1/tts',
      name: 'vrtPSTrainerTTSXCTRYOperate1TTS',
      component: () => import('./vpgPSTrainerTTSXCTRYOperate1TTS.vue'),
    },
    {
      path: 'tts/xctry/operate/summary/7s00',
      name: 'vrtPSTrainerTTSXCTRYOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - FORKLIFT
    {
      path: 'tts/fl/list',
      name: 'vrtPSTrainerTTSFLList',
      component: () => import('./vpgPSTrainerTTSFLList.vue'),
    },
    {
      path: 'tts/fl/operate/basic/b00',
      name: 'vrtPSTrainerTTSFLOperate1B00',
      component: () => import('./vpgPSTrainerTTSFLOperate1B00.vue'),
    },
    {
      path: 'tts/fl/operate/basic/b01',
      name: 'vrtPSTrainerTTSFLOperate1B01',
      component: () => import('./vpgPSTrainerTTSFLOperate1B01.vue'),
    },
    {
      path: 'tts/fl/operate/summary/7s00',
      name: 'vrtPSTrainerTTSFLOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - CL4S
    {
      path: 'tts/cl4s/list',
      name: 'vrtPSTrainerTTSCL4SList',
      component: () => import('./vpgPSTrainerTTSCL4SList.vue'),
    },
    {
      path: 'tts/cl4s/operate/basic/b00',
      name: 'vrtPSTrainerTTSCL4SOperate1B00',
      component: () => import('./vpgPSTrainerTTSCL4SOperate1B00.vue'),
    },
    {
      path: 'tts/cl4s/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL4SOperate1B01',
      component: () => import('./vpgPSTrainerTTSCL4SOperate1B01.vue'),
    },
    {
      path: 'tts/cl4s/operate/basic/b02',
      name: 'vrtPSTrainerTTSCL4SOperate1B02',
      component: () => import('./vpgPSTrainerTTSCL4SOperate1B02.vue'),
    },
    {
      path: 'tts/cl4s/operate/summary/7s00',
      name: 'vrtPSTrainerTTSCL4SOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - CL5
    {
      path: 'tts/cl5/list',
      name: 'vrtPSTrainerTTSCL5List',
      component: () => import('./vpgPSTrainerTTSCL5List.vue'),
    },
    {
      path: 'tts/cl5/operate/basic/b00',
      name: 'vrtPSTrainerTTSCL5Operate1B00',
      component: () => import('./vpgPSTrainerTTSCL5Operate1B00.vue'),
    },
    {
      path: 'tts/cl5/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL5Operate1B01',
      component: () => import('./vpgPSTrainerTTSCL5Operate1B01.vue'),
    },
    {
      path: 'tts/cl5/operate/summary/7s00',
      name: 'vrtPSTrainerTTSCL5Operate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - CL2
    {
      path: 'tts/cl2/list',
      name: 'vrtPSTrainerTTSCL2List',
      component: () => import('./vpgPSTrainerTTSCL2List.vue'),
    },
    {
      path: 'tts/cl2/operate/basic/b00',
      name: 'vrtPSTrainerTTSCL2Operate1B00',
      component: () => import('./vpgPSTrainerTTSCL2Operate1B00.vue'),
    },
    {
      path: 'tts/cl2/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL2Operate1B01',
      component: () => import('./vpgPSTrainerTTSCL2Operate1B01.vue'),
    },
    {
      path: 'tts/cl2/operate/basic/b02',
      name: 'vrtPSTrainerTTSCL2Operate1B02',
      component: () => import('./vpgPSTrainerTTSCL2Operate1B02.vue'),
    },
    {
      path: 'tts/cl2/operate/summary/7s00',
      name: 'vrtPSTrainerTTSCL2Operate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - CL2B
    {
      path: 'tts/cl2b/list',
      name: 'vrtPSTrainerTTSCL2BList',
      component: () => import('./vpgPSTrainerTTSCL2BList.vue'),
    },
    {
      path: 'tts/cl2b/operate/basic/b00',
      name: 'vrtPSTrainerTTSCL2BOperate1B00',
      component: () => import('./vpgPSTrainerTTSCL2BOperate1B00.vue'),
    },
    {
      path: 'tts/cl2b/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL2BOperate1B01',
      component: () => import('./vpgPSTrainerTTSCL2BOperate1B01.vue'),
    },
    {
      path: 'tts/cl2b/operate/basic/b02',
      name: 'vrtPSTrainerTTSCL2BOperate1B02',
      component: () => import('./vpgPSTrainerTTSCL2BOperate1B02.vue'),
    },
    {
      path: 'tts/cl2b/operate/summary/7s00',
      name: 'vrtPSTrainerTTSCL2BOperate7S00',
      component: () => import('./vpgPSTrainerTTSCL2BOperate7S00.vue'),
    },
    // TTS - CL2/2B FAM
    {
      path: 'tts/cl2fam/list',
      name: 'vrtPSTrainerTTSCL2FAMList',
      component: () => import('./vpgPSTrainerTTSCL2FAMList.vue'),
    },
    {
      path: 'tts/cl2fam/operate/basic/b00',
      name: 'vrtPSTrainerTTSCL2FAMOperate1B00',
      component: () => import('./vpgPSTrainerTTSCL2FAMOperate1B00.vue'),
    },
    {
      path: 'tts/cl2fam/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL2FAMOperate1B01',
      component: () => import('./vpgPSTrainerTTSCL2FAMOperate1B01.vue'),
    },
    // TTS - CL3 FAM
    {
      path: 'tts/cl3fam/list',
      name: 'vrtPSTrainerTTSCL3FAMList',
      component: () => import('./vpgPSTrainerTTSCL3FAMList.vue'),
    },
    {
      path: 'tts/cl3fam/operate/basic/b00',
      name: 'vrtPSTrainerTTSCL3FAMOperate1B00',
      component: () => import('./vpgPSTrainerTTSCL3FAMOperate1B00.vue'),
    },
    {
      path: 'tts/cl3fam/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL3FAMOperate1B01',
      component: () => import('./vpgPSTrainerTTSCL3FAMOperate1B01.vue'),
    },
    // TTS - CL4 FAM
    {
      path: 'tts/cl4fam/list',
      name: 'vrtPSTrainerTTSCL4FAMList',
      component: () => import('./vpgPSTrainerTTSCL4FAMList.vue'),
    },
    {
      path: 'tts/cl4fam/operate/basic/b00',
      name: 'vrtPSTrainerTTSCL4FAMOperate1B00',
      component: () => import('./vpgPSTrainerTTSCL4FAMOperate1B00.vue'),
    },
    {
      path: 'tts/cl4fam/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL4FAMOperate1B01',
      component: () => import('./vpgPSTrainerTTSCL4FAMOperate1B01.vue'),
    },
    // TTS - CL4S FAM
    {
      path: 'tts/cl4sfam/list',
      name: 'vrtPSTrainerTTSCL4SFAMList',
      component: () => import('./vpgPSTrainerTTSCL4SFAMList.vue'),
    },
    {
      path: 'tts/cl4sfam/operate/basic/b00',
      name: 'vrtPSTrainerTTSCL4SFAMOperate1B00',
      component: () => import('./vpgPSTrainerTTSCL4SFAMOperate1B00.vue'),
    },
    {
      path: 'tts/cl4sfam/operate/basic/b01',
      name: 'vrtPSTrainerTTSCL4SFAMOperate1B01',
      component: () => import('./vpgPSTrainerTTSCL4SFAMOperate1B01.vue'),
    },
    // TTS - RSAF
    {
      path: 'tts/rsaf/list',
      name: 'vrtPSTrainerTTSRSAFList',
      component: () => import('./vpgPSTrainerTTSRSAFList.vue'),
    },
    {
      path: 'tts/rsaf/operate/basic/b00',
      name: 'vrtPSTrainerTTSRSAFOperate1B00',
      component: () => import('./vpgPSTrainerTTSRSAFOperate1B00.vue'),
    },
    {
      path: 'tts/rsaf/operate/basic/b01',
      name: 'vrtPSTrainerTTSRSAFOperate1B01',
      component: () => import('./vpgPSTrainerTTSRSAFOperate1B01.vue'),
    },
    {
      path: 'tts/rsaf/operate/summary/7s00',
      name: 'vrtPSTrainerTTSRSAFOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - LHD
    {
      path: 'tts/lhd/list',
      name: 'vrtPSTrainerTTSLHDList',
      component: () => import('./vpgPSTrainerTTSLHDList.vue'),
    },
    {
      path: 'tts/lhd/operate/basic/b00',
      name: 'vrtPSTrainerTTSLHDOperate1B00',
      component: () => import('./vpgPSTrainerTTSLHDOperate1B00.vue'),
    },
    {
      path: 'tts/lhd/operate/basic/b01',
      name: 'vrtPSTrainerTTSLHDOperate1B01',
      component: () => import('./vpgPSTrainerTTSLHDOperate1B01.vue'),
    },
    {
      path: 'tts/lhd/operate/summary/7s00',
      name: 'vrtPSTrainerTTSLHDOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - AMBULANCE
    {
      path: 'tts/amb/list',
      name: 'vrtPSTrainerTTSAMBList',
      component: () => import('./vpgPSTrainerTTSAMBList.vue'),
    },
    {
      path: 'tts/amb/operate/basic/b00',
      name: 'vrtPSTrainerTTSAMBOperate1B00',
      component: () => import('./vpgPSTrainerTTSAMBOperate1B00.vue'),
    },
    {
      path: 'tts/amb/operate/basic/b01',
      name: 'vrtPSTrainerTTSAMBOperate1B01',
      component: () => import('./vpgPSTrainerTTSAMBOperate1B01.vue'),
    },
    {
      path: 'tts/amb/operate/summary/7s00',
      name: 'vrtPSTrainerTTSAMBOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - LSV
    {
      path: 'tts/lsv/list',
      name: 'vrtPSTrainerTTSLSVList',
      component: () => import('./vpgPSTrainerTTSLSVList.vue'),
    },
    {
      path: 'tts/lsv/operate/basic/b00',
      name: 'vrtPSTrainerTTSLSVOperate1B00',
      component: () => import('./vpgPSTrainerTTSLSVOperate1B00.vue'),
    },
    {
      path: 'tts/lsv/operate/basic/b01',
      name: 'vrtPSTrainerTTSLSVOperate1B01',
      component: () => import('./vpgPSTrainerTTSLSVOperate1B01.vue'),
    },
    {
      path: 'tts/lsv/operate/summary/7s00',
      name: 'vrtPSTrainerTTSLSVOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - LSV NS
    {
      path: 'tts/nslsv/list',
      name: 'vrtPSTrainerTTSNSLSVList',
      component: () => import('./vpgPSTrainerTTSNSLSVList.vue'),
    },
    {
      path: 'tts/nslsv/operate/basic/b00',
      name: 'vrtPSTrainerTTSNSLSVOperate1B00',
      component: () => import('./vpgPSTrainerTTSNSLSVOperate1B00.vue'),
    },
    {
      path: 'tts/nslsv/operate/basic/b01',
      name: 'vrtPSTrainerTTSNSLSVOperate1B01',
      component: () => import('./vpgPSTrainerTTSNSLSVOperate1B01.vue'),
    },
    {
      path: 'tts/nslsv/operate/summary/7s00',
      name: 'vrtPSTrainerTTSNSLSVOperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // TTS - FORD RANGER
    {
      path: 'tts/fgr/list',
      name: 'vrtPSTrainerTTSFGRList',
      component: () => import('./vpgPSTrainerTTSFGRList.vue'),
    },
    {
      path: 'tts/fgr/operate/basic/b00',
      name: 'vrtPSTrainerTTSFGROperate1B00',
      component: () => import('./vpgPSTrainerTTSFGROperate1B00.vue'),
    },
    {
      path: 'tts/fgr/operate/basic/b01',
      name: 'vrtPSTrainerTTSFGROperate1B01',
      component: () => import('./vpgPSTrainerTTSFGROperate1B01.vue'),
    },
    {
      path: 'tts/fgr/operate/summary/7s00',
      name: 'vrtPSTrainerTTSFGROperate7S00',
      component: () => import('./vpgPSTrainerTTSSummary7S00.vue'),
    },
    // FC
    {
      path: 'fc/list',
      name: 'vrtPSTrainerFCList',
      component: () => import('./vpgPSTrainerFCList.vue'),
    },
    {
      path: 'fc/operate',
      name: 'vrtPSTrainerFCOperate',
      component: () => import('./vpgPSTrainerFCOperate.vue'),
    },
    // CCDA
    {
      path: 'ccda/list',
      name: 'vrtPSTrainerCCDAList',
      component: () => import('./vpgPSTrainerCCDAList.vue'),
    },
    {
      path: 'ccda/operate',
      name: 'vrtPSTrainerCCDAOperate',
      component: () => import('./vpgPSTrainerCCDAOperate.vue'),
    },
    // eLAUNCH
    {
      path: 'elaunch/handbook',
      name: 'vrtPSTrainereLaunchHandbook',
      component: () => import('./vpgPSTrainereLaunchHandbook.vue'),
    },
    {
      path: 'elaunch/theoryofdriving',
      name: 'vrtPSTrainereLaunchTheoryOfDriving',
      component: () => import('./vpgPSTrainereLaunchTheoryOfDriving.vue'),
    },
    {
      path: 'elaunch/mocktest',
      name: 'vrtPSTrainereLaunchMockTest',
      component: () => import('./vpgPSTrainereLaunchMockTest.vue'),
    },
    //Vehicle Report
    {
      path: 'vehicle/report/vehiclelogbook/list',
      name: 'vrtPSTrainerVehicleReportLogbookList',
      component: () => import('./vpgPSTrainerReportVLogbookList.vue'),
    },
    {
      path: 'vehicle/report/vehiclelogbook/operate',
      name: 'vrtPSTrainerVehicleReportLogbookOperate',
      component: () => import('./vpgPSTrainerReportVLogbookOperate.vue'),
    },
    {
      path: 'vehicle/report/vmr/list',
      name: 'vrtPSTrainerVMileageRecordList',
      component: () => import('./vpgPSTrainerVMileageRecordList.vue'),
    },
    {
      path: 'vehicle/report/vmr/operate',
      name: 'vrtPSTrainerVMileageRecordOperate',
      component: () => import('./vpgPSTrainerVMileageRecordOperate.vue'),
    },
    {
      path: 'vehicle/report/vpol/list',
      name: 'vrtPSTrainerVPOLRecordList',
      component: () => import('./vpgPSTrainerVPOLRecordList.vue'),
    },
    {
      path: 'vehicle/report/vpol/operate',
      name: 'vrtPSTrainerVPOLRecordOperate',
      component: () => import('./vpgPSTrainerVPOLRecordOperate.vue'),
    },
    {
      path: 'vehicle/report/vwpt/list',
      name: 'vrtPSTrainerVWPTList',
      component: () => import('./vpgPSTrainerVWPTList.vue'),
    },
    {
      path: 'vehicle/report/vwpt/operate',
      name: 'vrtPSTrainerVWPTOperate',
      component: () => import('./vpgPSTrainerVWPTOperate.vue'),
    },
    {
      path: 'vehicle/report/vuqmavi/list',
      name: 'vrtPSTrainerVUQMAVIList',
      component: () => import('./vpgPSTrainerVUQMAVIList.vue'),
    },
    {
      path: 'vehicle/report/vuqmavi/operate',
      name: 'vrtPSTrainerVUQMAVIOperate',
      component: () => import('./vpgPSTrainerVUQMAVIOperate.vue'),
    },
    //Vehicle Log Book Sign Out list
    {
      path: 'vehicle/report/vehiclelogbook/signout/list',
      name: 'vrtPSTrainerVehicleLogbookSignOutList',
      component: () => import('./vpgPSTrainerVLogbookSignOutList.vue'),
    },
    //Vehicle Log Book Sign Out History
    {
      path: 'vehicle/report/vehiclelogbook/signout/history/list',
      name: 'vrtPSTrainerVehicleLogbookSignOutHistoryList',
      component: () => import('./vpgPSTrainerVLogbookSignOutHistory.vue'),
    },
    // FAMILIRISATION TRAINING ASSESSMENT
    {
      path: 'fta/ftaassessmentlist',
      name: 'vrtPSTrainerVBFTAssessment',
      component: () => import('./vpgPSTrainerVBFTAssessment.vue'),
    },
    {
      path: 'fta/ftaassessmentoperate',
      name: 'vrtPSTrainerVBFTAssessmentOperate',
      component: () => import('./vpgPSTrainerVBFTAssessmentOperate.vue'),
    },
    {
      path: 'amb/ambassessmentlist',
      name: 'vrtPSTrainerAMBAssessment',
      component: () => import('./vpgPSTrainerAMBAssessment.vue'),
    },
    {
      path: 'amb/ambassessmentoperate',
      name: 'vrtPSTrainerAMBAssessmentOperate',
      component: () => import('./vpgPSTrainerAMBAssessmentOperate.vue'),
    },
    {
      path: 'lsv/lsvassessmentoperate',
      name: 'vrtPSTrainerLSVAssessmentOperate',
      component: () => import('./vpgPSTrainerTTSLSVOperateAssessment.vue'),
    },
    {
      path: 'lsv/lsvassessmentlist',
      name: 'vrtPSTrainerLSVAssessmentList',
      component: () => import('./vpgPSTrainerTTSLSVAssessmentList.vue'),
    },
    // EHELP
    {
      path: 'ehelp/operate',
      name: 'vrtPSTrainereHelpOperate',
      component: () => import('./vpgPSTrainereHelpOperate.vue'),
    },
    {
      path: 'ehelp/case/create',
      name: 'vrtPSTrainereHelpCaseCreate',
      component: () => import('./vpgPSTrainereHelpCaseCreate.vue'),
    },
    {
      path: 'ehelp/history',
      name: 'vrtPSTrainereHelpHistory',
      component: () => import('./vpgPSTrainereHelpHistory.vue'),
    },
  ],
};
//
// VEHICLE
// {},
// FAMILIARISATION & ASSESSMENT
// {},
// STATEMENT
// {}.
// ANNUAL CURRENCY PRACTICAL ASSESSMENT
// {},
// TLS (Testing Licensing Section)
// {},
//
export default vrtPSTrainer;
